<div class="card border-0 shadow-sm pt-0 mb-4">
    <div class="card-header d-flex justify-content-between align-items-center fs-5 fw-medium">
        <span>Guard House</span>
        <span class="text-muted fs-5">
            ID: {{ appointment.numberWithPrefix }}
        </span>
    </div>
    <div class="card-body">
        <div class="row g-3 mt-1">
            <div class="col-md-4">
                <label class="form-label">Carrier: <span class="text-danger">*</span></label>
                <dx-select-box [(value)]="appointment.carrierId" [dataSource]="carrierDataSource"
                    displayExpr="name" valueExpr="id" [searchEnabled]="true" [showClearButton]="true"
                    stylingMode="filled" placeholder="Select..." [readOnly]="true">
                </dx-select-box>
            </div>
            <div class="col-md-4">
                <label class="form-label">Bill Of Lading Number:</label>
                <dx-text-box stylingMode="filled" [(value)]="appointment.billOfLadingNumber"
                    maxLength="100" placeholder="Enter Bill Of Lading Number" [readOnly]="true">
                </dx-text-box>
            </div>
            <div class="col-md-4">
                <label class="form-label">Trailer Number:</label>
                <dx-text-box stylingMode="filled" [(value)]="appointment.trailerNumber"
                    maxLength="100" placeholder="Enter Trailer Number" [readOnly]="true">
                </dx-text-box>
            </div>
        </div>
        <div class="row g-3 mt-1">
            <div class="col-md-4"></div>
            <div class="col-md-4">
                <label class="form-label">Is BOL number correct?*</label>
                <dx-radio-group
                    class="flex-shrink-0"
                    layout="horizontal"
                    [items]="yesNoOptions"
                    valueExpr="value"
                    displayExpr="text"
                    [(value)]="appointment.isBillOfLadingNumberCorrect"
                    [readOnly]="isReadOnly"
                >
                    <dx-validator>
                        <dxi-validation-rule type="custom" [validationCallback]="validate" message="Selection is required"></dxi-validation-rule>
                    </dx-validator>
                </dx-radio-group>
                @if (!appointment.isBillOfLadingNumberCorrect && appointment.isBillOfLadingNumberCorrect !== null) {
                    <div class="mt-2 animate-fade-in">
                        <label class="form-label">Correct BOL Number:*</label>
                        <dx-text-box stylingMode="filled" [(value)]="appointment.correctBillOfLadingNumber"
                            maxLength="20" placeholder="Enter Correct BOL Number" [readOnly]="isReadOnly">
                            <dx-validator>
                                <dxi-validation-rule type="custom" [validationCallback]="validate" message="Correct BOL Number is required"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                }
            </div>
            <div class="col-md-4">
                <label class="form-label">Is trailer number correct?*</label>
                <dx-radio-group
                    class="flex-shrink-0"
                    layout="horizontal"
                    [items]="yesNoOptions"
                    valueExpr="value"
                    displayExpr="text"
                    [(value)]="appointment.isTrailerNumberCorrect"
                    [readOnly]="isReadOnly"
                >
                    <dx-validator>
                        <dxi-validation-rule type="custom" [validationCallback]="validate" message="Selection is required"></dxi-validation-rule>
                    </dx-validator>
                </dx-radio-group>
                @if (!appointment.isTrailerNumberCorrect && appointment.isTrailerNumberCorrect !== null) {
                    <div class="mt-2 animate-fade-in">
                        <label class="form-label">Correct Trailer Number:*</label>
                        <dx-text-box stylingMode="filled" [(value)]="appointment.correctTrailerNumber"
                            maxLength="20" placeholder="Enter Correct Trailer Number" [readOnly]="isReadOnly">
                            <dx-validator>
                                <dxi-validation-rule type="custom" [validationCallback]="validate" message="Correct Trailer Number is required"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                }
            </div>
        </div>
        <div class="row g-3 mt-1">
            <div class="col-md-4">
                <label class="form-label">Driver Name:*</label>
                <dx-text-box stylingMode="filled" [(value)]="appointment.driverName"
                    maxLength="200" placeholder="Enter Driver Name" [readOnly]="isReadOnly">
                    <dx-validator>
                        <dxi-validation-rule type="custom" [validationCallback]="validate" message="Driver Name is required"></dxi-validation-rule>
                    </dx-validator>
                </dx-text-box>
            </div>
            <div class="col-md-4">
                <label class="form-label">Driver ID:*</label>
                <dx-text-box stylingMode="filled" [(value)]="appointment.driverId"
                    maxLength="100" placeholder="Enter Driver ID" [readOnly]="isReadOnly">
                    <dx-validator>
                        <dxi-validation-rule type="custom" [validationCallback]="validate" message="Driver ID is required"></dxi-validation-rule>
                    </dx-validator>
                </dx-text-box>
            </div>
            <div class="col-md-4">
                <label class="form-label">Trailer Type:*</label>
                <dx-select-box
                    stylingMode='filled'
                    valueExpr="value"
                    displayExpr="text"
                    [items]="trailerTypeOptions"
                    [(value)]="appointment.trailerType"
                    [readOnly]="isReadOnly"
                >
                    <dx-validator>
                        <dxi-validation-rule type="custom" [validationCallback]="validate" message="Trailer Type is required"></dxi-validation-rule>
                    </dx-validator>
                </dx-select-box>
            </div>
        </div>
        <div class="row g-3 mt-1">
            <div class="col-md-4">
                <label class="form-label">Trailer Temperature:</label>
                <dx-text-box stylingMode="filled" [(value)]="appointment.trailerTemperature"
                    maxLength="20" placeholder="Enter Trailer Temperature" [readOnly]="isReadOnly">
                </dx-text-box>
            </div>
            <div class="col-md-4">
                <label class="form-label">Seal Number:*</label>
                <dx-text-box stylingMode="filled" [(value)]="appointment.sealNumber"
                    maxLength="100" placeholder="Enter Seal Number" [readOnly]="isReadOnly">
                    <dx-validator>
                        <dxi-validation-rule type="custom" [validationCallback]="validate" message="Seal Number is required"></dxi-validation-rule>
                    </dx-validator>
                </dx-text-box>
            </div>
            <div class="col-md-4">
                <label class="form-label">Seal matches paperwork?*</label>
                <dx-select-box
                    stylingMode='filled'
                    valueExpr="value"
                    displayExpr="text"
                    [items]="yesNoOptions"
                    [(value)]="appointment.sealMatchesPaperwork"
                    [readOnly]="isReadOnly"
                >
                    <dx-validator>
                        <dxi-validation-rule type="custom" [validationCallback]="validate" message="Selection is required"></dxi-validation-rule>
                    </dx-validator>
                </dx-select-box>
            </div>
        </div>
        <div class="row g-3 mt-1">
            <div class="col-md-4">
                <label class="form-label">Location:*</label>
                <dx-select-box
                    stylingMode='filled'
                    valueExpr="value"
                    displayExpr="text"
                    [items]="shuntLocationOptions"
                    [(value)]="appointment.guardHouseLocation"
                    (onValueChanged)="onLocationTypeChanged($event)"
                    [readOnly]="isReadOnly || !appointment.canEditGuardHouseLocation"
                >
                    <dx-validator>
                        <dxi-validation-rule type="custom" [validationCallback]="validate"></dxi-validation-rule>
                    </dx-validator>
                </dx-select-box>
            </div>
            @if(appointment.guardHouseLocation !== null &&
                appointment.guardHouseLocation !== guardHouseLocation.Office)
            {
                <div class="col-md-4">
                    <label class="form-label">Location #:*</label>
                    <dx-select-box
                        stylingMode="filled"
                        valueExpr="id"
                        displayExpr="number"
                        [value]="appointment.guardHouseLocationId"
                        (onValueChanged)="onValueChanged($event.value)"
                        [dataSource]="shuntLocationDataSource"
                        placeholder="Select a location"
                        [searchEnabled]="true"
                        [readOnly]="isReadOnly || !appointment.canEditGuardHouseLocation"
                    >
                        <dx-validator>
                                <dxi-validation-rule type="custom" [validationCallback]="validate"></dxi-validation-rule>
                        </dx-validator>
                    </dx-select-box>
                </div>
            }
        </div>
    </div>
</div>
